import React from "react"
import {
	Grid,
	IconButton,
	List,
	ListItem,
	ListItemText,
	Popover,
	Tooltip
} from "@material-ui/core"

import { AccessAlarm as SnoozeIcon } from "@material-ui/icons"

import { useChatGlobalStateStore } from "@/store/ChatGlobalState"
import { useGlobalStateStore } from "@/store/GlobalState"
import SnoozeGroupPermissionGate from "@/components/PermissionGate/SnoozeGroupPermissionGate"

import { AttendanceStatus } from "@/protocols/channel"

import ScheduledSnoozeDialog from "@/pages/Attendance/Chat/ConversationPanel/ConversationHeader/NewSnooze/dialogs/ScheduledSnoozeDialog"
import SimpleMessageDialog from "@/pages/Attendance/Chat/ConversationPanel/ConversationHeader/NewSnooze/dialogs/SimpleMessageDialog"
import WABATemplateMessageDialog from "@/pages/Attendance/Chat/ConversationPanel/ConversationHeader/NewSnooze/dialogs/WABATemplateMessageDialog"
import SnoozeDialog from "@/pages/Attendance/Chat/ConversationPanel/ConversationHeader/NewSnooze/dialogs/SnoozeDialog"
import { colors } from "@/styles/colors"
import AnalyticsService from "@/services/Analytics"

type SnoozeDialogProps = {
	inboxChannelChatId: number
}

const ManageSnooze: React.FC<SnoozeDialogProps> = (props) => {
	const {
		inboxChannelChatId
	} = props

	const chatGlobalStateStore = useChatGlobalStateStore()
	const globalStateStore = useGlobalStateStore()
	const currentChannel = globalStateStore.currentChannel
	const instanceId = globalStateStore.instance.instance_id
	const userId = globalStateStore.user.id

	const isWABACurrentChannel = currentChannel?.channelType === "waba"

	const inboxChannelChat = chatGlobalStateStore.chat.getById(inboxChannelChatId)

	const currentChatAttendanceStatus = inboxChannelChat?.attendance?.status as AttendanceStatus
	const isAttendanceStatusSnooze = inboxChannelChat?.status === "snooze"
	const isAttendanceStatusActive = currentChatAttendanceStatus === "active"

	const isScheduledSnooze = isAttendanceStatusActive && isAttendanceStatusSnooze
	const scheduleSnoozeId = chatGlobalStateStore.chat.current?.schedule?.snooze_id
	const scheduleTime = chatGlobalStateStore.chat.current?.schedule?.time

	const [moreOptionsMenuAnchorEl, setMoreOptionsMenuAnchorEl] = React.useState<null | HTMLElement>(null)
	const moreOptionsMenuIsOpen = Boolean(moreOptionsMenuAnchorEl)

	const handleMoreOptionsMenuClose = () => {
		setMoreOptionsMenuAnchorEl(null)
	}

	const handleSnoozeIconClick = () => {
		AnalyticsService.capture("snooze_icon_clicked")
	}

	const handleMoreOptionsMenuClick = (event: React.MouseEvent<HTMLElement>) => {
		handleSnoozeIconClick()
		setMoreOptionsMenuAnchorEl(event.currentTarget)
	}

	return (
		<Grid>
			{isScheduledSnooze ? (
				<ScheduledSnoozeDialog
					inboxChannelChatId={inboxChannelChatId}
					snoozeId={Number(scheduleSnoozeId)}
					scheduleTime={scheduleTime}
					inboxChannelId={currentChannel?.id as number}
				>
					<Tooltip
						title="Soneca"
					>
						<SnoozeGroupPermissionGate action="manage">
							<IconButton
								id="snoozePopover"
								aria-label="more"
								aria-controls="long-menu"
								aria-haspopup="true"
								onClick={handleSnoozeIconClick}
								style={{ display: "block" }}
							>
								<SnoozeIcon htmlColor={colors.yellow[400]} />
							</IconButton>
						</SnoozeGroupPermissionGate>
					</Tooltip>
				</ScheduledSnoozeDialog>
			) : (
				<Tooltip
					title="Soneca"
				>
					<SnoozeGroupPermissionGate action="manage">
						<IconButton
							id="snoozePopover"
							aria-label="more"
							aria-controls="long-menu"
							aria-haspopup="true"
							onClick={handleMoreOptionsMenuClick}
							style={{ display: isAttendanceStatusActive ? "block" : "none" }}
						>
							<SnoozeIcon />
						</IconButton>
					</SnoozeGroupPermissionGate>
				</Tooltip>
			)}

			<Popover
				open={moreOptionsMenuIsOpen}
				anchorEl={moreOptionsMenuAnchorEl}
				onClose={handleMoreOptionsMenuClose}
				anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
				transformOrigin={{ vertical: "bottom", horizontal: "left" }}
			>
				<List>
					<SnoozeDialog
						inboxChannelChatId={inboxChannelChatId}
						onClose={handleMoreOptionsMenuClose}
						userId={userId}
						instanceId={instanceId}
					>
						<ListItem button>
							<ListItemText primary="Soneca" />
						</ListItem>
					</SnoozeDialog>
					<SimpleMessageDialog
						inboxChannelChatId={inboxChannelChatId}
						onClose={handleMoreOptionsMenuClose}
						userId={userId}
						instanceId={instanceId}
					>
						<ListItem button>
							<ListItemText primary="Soneca com mensagem simples" />
						</ListItem>
					</SimpleMessageDialog>

					{isWABACurrentChannel && (
						<WABATemplateMessageDialog
							inboxChannelChatId={inboxChannelChatId}
							inboxChannelId={currentChannel?.id}
							onClose={handleMoreOptionsMenuClose}
							userId={userId}
							instanceId={instanceId}
						>
							<ListItem button>
								<ListItemText primary="Soneca com Template Waba" />
							</ListItem>
						</WABATemplateMessageDialog>
					)}
				</List>
			</Popover>
		</Grid>
	)
}

export default ManageSnooze
